import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_798_290",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 36,
			height: 36,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 18,
				cy: 18,
				r: 18,
				fill: "#0D081C"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_798_290)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 18,
					cy: 18,
					r: 18,
					fill: "url(#paint0_radial_798_290)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.99442 31.3789C9.52459 28.115 13.5101 26 18 26C22.4899 26 26.4754 28.115 29.0056 31.3789C29.017 31.3936 29.0285 31.4084 29.04 31.4233C29.2576 31.7037 29.4909 32.0044 29.6575 32.2945C29.8593 32.6456 30.0089 33.0517 29.9996 33.5457C29.9921 33.9428 29.8687 34.3145 29.7188 34.608C29.5689 34.9015 29.3391 35.2215 29.0186 35.4667C28.5911 35.7937 28.1257 35.9094 27.7123 35.9578C27.3495 36.0002 26.9197 36.0001 26.4875 36C26.468 36 26.4486 36 26.4291 36H9.57092C9.55144 36 9.53196 36 9.51249 36C9.08032 36.0001 8.65047 36.0002 8.28774 35.9578C7.8743 35.9094 7.4089 35.7937 6.98144 35.4667C6.6609 35.2215 6.43105 34.9015 6.28117 34.608C6.13129 34.3145 6.00786 33.9428 6.00041 33.5457C5.99114 33.0517 6.14068 32.6456 6.34245 32.2945C6.50915 32.0044 6.74242 31.7037 6.95996 31.4233C6.97149 31.4084 6.98298 31.3936 6.99442 31.3789Z",
					fill: "#DFCBF5",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 18,
					cy: 15,
					r: 7,
					fill: "#DFCBF5",
					fillOpacity: .6
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_798_290",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(18 18) rotate(90) scale(18)",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .2
			})]
		}) })
	]
});
export default SvgProfile;
